import {
	bikeRegisteredEnum,
	useBikeRegistrationProcess,
} from "features/dashboard/hooks/useBikeRegistrationProcess"
import React from "react"

import { CodeValidationForm } from "./CodeValidationForm"
import { InitialForm } from "./InitialForm"

type AddBikeBFormProps = {
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>
	refreshBikes: () => Promise<void>
}

export const AddBikeForm: React.FC<AddBikeBFormProps> = ({ setModalIsOpen, refreshBikes }) => {
	const { bikeRegistrationState } = useBikeRegistrationProcess()

	const isCodeValidationStep =
		bikeRegistrationState.step === bikeRegisteredEnum.codeValidationStep

	if (isCodeValidationStep) {
		return <CodeValidationForm setModalIsOpen={setModalIsOpen} refreshBikes={refreshBikes} />
	}

	return <InitialForm setModalIsOpen={setModalIsOpen} />
}
